




























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class RespondecoPager extends Vue {
  @Prop({
    default: 10,
    type: Number,
  })
  public readonly pageSize!: number

  @Prop({
    default: () => [10, 25, 50, 100],
    type: Array,
  })
  public readonly sizes!: number[]

  public changePageSize(pageSize: string): void {
    this.$emit('pageSize', Number(pageSize))
  }
}
